import axios from 'axios';

export const canUserPreviewDocument = async (documentUuid: string, documentType: string): Promise<string> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/document-preview/${documentUuid}/${documentType}/check-document-permission`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.error));
  });
};
